<template>
  <div class="download-root" :style="{ ...background }">
    <div class="background-wrapper">
      <img class="sp3" src="/assets/images/bg-lbf.png" alt="" />
      <img class="sp6" src="/assets/images/bg-rbf.png" alt="" />
      <img class="sp1" src="/assets/images/bg-lt.png" alt="" />
      <img class="sp2" src="/assets/images/bg-lb.png" alt="" />
      <img class="sp4" src="/assets/images/bg-rt.png" alt="" />
      <img class="sp5" src="/assets/images/bg-rb.png" alt="" />
      <img class="sp7" src="/assets/images/qp.png" alt="" />
    </div>
    <div class="container" v-show="!hasError">
      <div
        class="mid"
        v-loading="isLoading"
        element-loading-background="rgba(0,0,0,0)"
      >
        <img class="zylkcss" src="/assets/images/zylk.png" />
      </div>
      <div class="app-info mid" v-show="!isLoading">
        <div class="code">
          <canvas class="qrcode" width="180" ref="qrcodeRef"></canvas>
        </div>
        <div class="app-name">{{ fileName }}</div>
        <div class="app-version">
          <img src="/assets/images/footericon.png" alt="" />
          <span>{{ versionMsg }}</span>
        </div>
        <div class="download-button" @click="handleDownload">
          <img src="/assets/images/clouddownload.png" alt="" />
          &nbsp;下载文件
        </div>
      </div>
    </div>
    <div class="container error-tip" v-show="hasError">
      <div class="mid">
        <div>出错了： {{ errorMessage }}</div>
        <br />
<!--        <router-link to="/home"-->
<!--          ><div class="home-button">回到首页</div></router-link-->
<!--        >-->
      </div>
    </div>
  </div>
</template>

<script setup>
import { getCurrentInstance, onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import QRCode from "qrcode";
import { apiResoueceDownload } from "@/Api/AppApi";

const { appContext } = getCurrentInstance();
const $moment = appContext.config.globalProperties.$moment;

const route = useRoute();

const errorMessage = ref("");
const hasError = ref(false);
const uri = ref("");
watch(
  () => route.params?.uri,
  (val) => {
    if (!val) {
      errorMessage.value = "缺少app短链";
      hasError.value = true;
      return;
    }
    hasError.value = false;
    uri.value = val;
    getFileInfo();
  },
  { immediate: true }
);
onMounted(() => {
  const url = route.query?.url;
  if (url) {
    window.location.href = url;
    return;
  }
  uri.value = route.params?.uri;
  if (uri.value) {
    hasError.value = false;
    getFileInfo();
  } else {
    hasError.value = true;
    errorMessage.value = "缺少app短链";
  }
});

const background = ref({ backgroundColor: "#1f86e4", backgroundImage: "none" });

const isLoading = ref(false);
const fileName = ref("");
const versionMsg = ref("");
const qrcodeRef = ref(null);
let file = null;
async function getFileInfo() {
  isLoading.value = true;
  const res = await apiResoueceDownload({ id: [uri.value] });
  isLoading.value = false;
  if (res.code === 0) {
    file = res.data[0];
    initDataShow();
  } else {
    hasError.value = true;
    if (res.code === 28) {
      errorMessage.value = "没有找到相关文件";
    } else {
      errorMessage.value = res.message;
    }
  }
}
function initDataShow() {
  fileName.value = file.file_name;

  versionMsg.value = `${humanSize(file.size, 1)} 上传时间: ${$moment(
    file.first_created
  ).format("YYYY/MM/DD HH:mm")}`;

  QRCode.toCanvas(
    qrcodeRef.value,
    location.href,
    {
      maskPattern: 4,
      width: 180,
      margin: 2,
      errorCorrectionLevel: "H",
    },
    (err) => {
      if (err) {
        console.log(err);
        hasError.value = true;
        errorMessage.value = "二维码生成失败";
      }
    }
  );
}

function handleDownload() {
  doDownload(file.url);
}

async function doDownload(url) {
  if (url) {
    const node = document.createElement("a");
    node.href = url;
    node.click();
    node.remove();
  }
}

const mags = "BKMGTPEZY";
function humanSize(bytes, precision) {
  const magnitude = Math.min(
    (Math.log(bytes) / Math.log(1024)) | 0,
    mags.length - 1
  );
  const result = bytes / Math.pow(1024, magnitude);
  const suffix = mags[magnitude].trim();
  return result.toFixed(precision) + suffix;
}
</script>

<style lang="scss" scoped>
.download-root {
  height: 100%;
  width: 100%;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: 100%;
  position: relative;
}

.background-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;

  .sp3 {
    position: absolute;
    bottom: 170px;
  }

  .sp6 {
    position: absolute;
    bottom: 160px;
    right: 38px;
  }

  .sp1 {
    position: absolute;
    top: 0px;
  }

  .sp2 {
    position: absolute;
    bottom: 0px;
  }

  .sp4 {
    position: absolute;
    top: 0px;
    right: 0px;
  }

  .sp5 {
    position: absolute;
    bottom: 0px;
    right: -50px;
  }

  .sp7 {
    position: absolute;
  }
}

.container {
  width: 100%;
  height: 100%;

  .mid {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: absolute;
  }

  .zylkcss {
    min-width: 576px;
    max-width: 724px;
    max-height: 797px;
    height: auto;
    width: 34%;
    margin-top: -23px;
  }

  .code {
    position: relative;
  }

  .app-name {
    font-size: 20px;
    color: #fff;
    margin: 18px 0;
  }

  .app-version {
    font-size: 12px;
    color: #fff;

    img {
      vertical-align: bottom;
    }
    span {
      margin-left: 4px;
    }
  }

  .download-button {
    border: 1px solid #fff;
    width: 200px;
    height: 48px;
    color: #fff;
    font-size: 21px;
    margin: 42px 0;
    cursor: pointer;
    text-align: center;
    line-height: 48px;
    vertical-align: middle;
    border-radius: 4px;
    user-select: none;
  }
}

.error-tip {
  color: #fff;
  font-size: 16px;

  .home-button {
    color: #fff;
    cursor: pointer;
    border: 1px solid #fff;
    width: 200px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    border-radius: 4px;
    user-select: none;
  }
}
</style>
